import { type FilterFn, type Row } from '@tanstack/react-table'

// Custom filter for tri-state checkbox, showing all (''), true, or false
export const booleanFilterFn: FilterFn<any> = (row: Row<any>, columnId: string, filterValue: string) => {
  const rowValue = row.getValue(columnId)
  if (filterValue === '') {
    return true
  }
  // If column is a string and filterValue is 'true', show if non-empty
  if (typeof rowValue === 'string' && filterValue === 'true') {
    return rowValue.trim().length > 0
  }
  return String(rowValue) === filterValue
}

export const dateFilterFn: FilterFn<any> = (row: Row<any>, columnId: string, filterValue: string) => {
  if (!filterValue) return true
  const rowValue = row.original[columnId]
  if (!rowValue) return false
  const dateFilterValue = new Date(filterValue)
  const dateValue = new Date(rowValue)
  return dateValue.toDateString().includes(dateFilterValue.toDateString())
}
export const textFilterFn: FilterFn<any> = (row: Row<any>, columnId: string, filterValue: string) => {
  const cellValue = row.getValue(columnId)
  return filterValue === cellValue || String(cellValue).includes(filterValue)
}

// Only exact match
export const enumFilterFn: FilterFn<any> = (row: Row<any>, columnId: string, filterValue: string) => {
  const cellValue = row.getValue(columnId)
  return filterValue === cellValue
}
